var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgB12Logo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:#EE764E;}\n\t.st2{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "-460,-40 1460,-40 1460,1040 -460,1040  "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M848.5,700.7c0,140-113.5,253.5-253.4,253.5H222.9c-39.4,0-71.4-32-71.4-71.4V518.6c0-2.7,0.2-5.4,0.4-8    c-0.3-2.6-0.4-5.3-0.4-8V117.2c0-39.5,32-71.4,71.4-71.4h234.9c145.8,0,264,118.2,264,264.1c0,55.8-17.3,107.5-46.8,150.1    C775.8,493.5,848.5,588.6,848.5,700.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M294.5,803.1c0,16.4,13.4,29.7,30.1,29.7c16.6,0,30.1-13.3,30.1-29.7V582.5c0-16.4-13.4-29.7-30.1-29.7h-0.8    c-8.3,0-17,1.9-28.5,5.1l-39.2,11.4c-12.3,3.5-20.2,13.7-20.2,25.8c0,14.1,12.3,25.8,26.5,25.8c3.2,0,7.5-0.8,10.7-1.6l21.4-5.5    V803.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M408,801.9c0,18,13.8,28.6,32.8,28.6h150.4c14.6,0,26.5-11.4,26.5-25.8c0-14.5-11.9-26.2-26.5-26.2h-96.6    l45.1-34.4c49.1-37.5,72.8-60.2,72.8-106v-0.8c0-51.2-38-84.5-95.4-84.5c-42,0-68.1,14.9-90.2,40.3c-4.4,5.1-7.1,12.1-7.1,18.8    c0,15.3,12.3,27.4,27.7,27.4c9.5,0,16.6-4.3,20.6-8.6c15.4-16.4,27.7-23.9,45.1-23.9c21.8,0,37.2,12.5,37.2,35.6    c0,22.7-13.4,37.9-47.9,65.7l-78.8,63.8C413.6,780,408,790.2,408,801.9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgB12Logo);
export default __webpack_public_path__ + "static/media/b12_logo.01c117d538f700c76803e090cee7f744.svg";
export { ForwardRef as ReactComponent };